import gql from 'graphql-tag';

const CLUB_REGISTER_REQUEST_CANCEL= gql`
mutation clubRegisterRequestCancel($id: ID!) { 
  clubRegisterRequestCancel(id: $id) {
    id
    bid
    type
    status
    createdAt
  }
} 
`;

export default CLUB_REGISTER_REQUEST_CANCEL;